var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#BCE1FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6225_20264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.172 71.7873C111.829 66.772 106.942 62.2559 101.6 58.3225C101.127 57.9912 100.563 57.8135 99.9859 57.8135C99.4086 57.8135 98.8452 57.9912 98.3723 58.3225C93.0399 62.2576 88.1619 66.7736 83.8281 71.7873C74.1637 82.8861 69.0625 94.5861 69.0625 105.625C69.0625 113.83 72.322 121.699 78.1239 127.501C83.9258 133.303 91.7949 136.563 100 136.563C108.205 136.563 116.074 133.303 121.876 127.501C127.678 121.699 130.938 113.83 130.938 105.625C130.938 94.5861 125.836 82.8861 116.172 71.7873ZM119.635 108.909C118.905 112.982 116.946 116.735 114.019 119.661C111.093 122.587 107.34 124.546 103.266 125.274C103.116 125.298 102.964 125.311 102.812 125.313C102.107 125.312 101.427 125.047 100.908 124.569C100.389 124.092 100.069 123.436 100.01 122.733C99.952 122.03 100.16 121.331 100.593 120.774C101.026 120.217 101.653 119.843 102.348 119.726C108.174 118.745 113.117 113.803 114.105 107.967C114.23 107.231 114.642 106.575 115.25 106.143C115.859 105.711 116.614 105.539 117.35 105.664C118.085 105.789 118.741 106.201 119.173 106.809C119.605 107.418 119.777 108.173 119.652 108.909H119.635Z",
    fill: "#272727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6225_20264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(55 55)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValley);
export default __webpack_public_path__ + "static/media/valley.d92927bb1dfda3ef12b0d54bc72676e3.svg";
export { ForwardRef as ReactComponent };